import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { ShippingModal } from './ShippingModal';
import { TermsModal } from './TermsModal';
import { RefundPolicyModal } from './RefundPolicyModal';
export const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isShippingModalOpen, setIsShippingModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  return <footer className="py-8 bg-blue-900 border-t border-gray-200 relative" data-id="element-89">
      {/* Subtle stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-90">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-91"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-92">
        <div className="text-center text-gray-200 text-sm" data-id="element-93">
          {/* E-commerce footer links */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-6" data-id="element-94">
            <button onClick={() => setIsShippingModalOpen(true)} className="text-gray-300 hover:text-white transition-colors" data-id="element-95">
              Shipping Information
            </button>
            <a href="https://www.voicesoffreedomus.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" data-id="element-96">
              Visit Our Store
            </a>
            <button onClick={() => setIsTermsModalOpen(true)} className="text-gray-300 hover:text-white transition-colors" data-id="element-97">
              Terms of Service
            </button>
            <button onClick={() => setIsRefundModalOpen(true)} className="text-gray-300 hover:text-white transition-colors" data-id="element-98">
              Refund Policy
            </button>
          </div>
          <div className="border-t border-gray-600 pt-4 mt-6" data-id="element-99">
            <button onClick={() => setIsPrivacyModalOpen(true)} className="text-gray-300 hover:text-white underline text-sm transition-colors" data-id="element-100">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
      {/* Modals */}
      {isPrivacyModalOpen && <PrivacyPolicyModal onClose={() => setIsPrivacyModalOpen(false)} data-id="element-101" />}
      {isShippingModalOpen && <ShippingModal onClose={() => setIsShippingModalOpen(false)} data-id="element-102" />}
      {isTermsModalOpen && <TermsModal onClose={() => setIsTermsModalOpen(false)} data-id="element-103" />}
      {isRefundModalOpen && <RefundPolicyModal onClose={() => setIsRefundModalOpen(false)} data-id="element-104" />}
    </footer>;
};